export default "__VITE_ASSET__BAcXAXEc__"